import { AnimatedText } from "../components/shared/AnimatedText";
import { MentorSlider } from "../components/Mentors/MentorSlider";
import { MENTORS_I18N } from "../data/mentors";

export function MentorsSection({ t, lang }) {
  return (
    <section id="mentors" className="bg-white py-12 md:py-20">
      <div className="w-full px-3 md:px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 md:mb-14">
            <AnimatedText text={t.mentors.title} tag="h2" className="text-3xl md:text-5xl font-black text-blue-900 mb-4" />
            <AnimatedText text={t.mentors.subtitle} tag="p" delay={80} className="text-gray-700 text-base md:text-lg max-w-3xl mx-auto" />
          </div>
        </div>
        <div className="w-full max-w-screen-xl mx-auto" style={{ paddingLeft: 36, paddingRight: 36 }}>
          <MentorSlider mentors={MENTORS_I18N[lang] || MENTORS_I18N.en} />
        </div>
      </div>
    </section>
  );
}
